"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _i;

var Loader = function Loader(_ref) {
  var loading = _ref.loading,
      children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      element = _ref.element;

  // If we arent in a loading state, just return the children
  if (!loading) {
    return children;
  } // If we are in a loading state and have a custom loading element, display it


  if (element) {
    return element;
  } // If we are in a loading state but have no custom loading element, display the default and pass any styling


  return /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    style: style
  }, _i || (_i = /*#__PURE__*/(0, _jsx2.default)("i", {
    className: "icon icon-load icon-spin"
  })));
};

var _default = Loader;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/Loader.js
// module id = 36
// module chunks = 25